<template>
  <div>
    <Form
      ref="form"
      class="RealisationDetail PageWrapper DetailGrid"
      @error="handleValidationError"
      @submit="handleSubmit"
    >
      <RealisationHeader
        :feedback="feedback"
        :feedback-message="feedbackMessage"
        :step="currentStep"
        :record-step="step"
        :record="record"
      >
        <b-button
          variant="outline-light"
          class="ml-3"
          size="sm"
          type="submit"
          :disabled="disabled"
          @click.prevent.stop="handlePrevious"
        >
          Vorige stap
        </b-button>

        <template v-if="! locked">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
          >
            Opslaan
          </b-button>
          <b-button
            v-if="step !== currentStep"
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleCancelChange"
          >
            Annuleren
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleSubmitAndNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else-if="mayEdit">
          <!-- <b-button v-if="openForChange" variant="outline-light" class="ml-3" size="sm" type="submit" :disabled="disabled"
            @click.prevent.stop="handleStartChange">
            Wijzigen
          </b-button> -->
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || step <= currentStep"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>
      </RealisationHeader>

      <RealisationSidebar
        :uuid="uuid"
        :disabled="disabled || locked"
      />

      <div
        v-if="! reloading"
        class="DetailGrid__col1"
      >
        <TrafficDecision
          :values="values"
          :disabled="locked || disabled"
          @setDefinitiveDate="handleDefinitiveDate"
        />

        <div v-if="isGORALTenant">
          <h3>Verkeersbesluit document</h3>
          <FilesManager
            :uuid="uuid"
            :disabled="disabled"
            :locked="locked"
            :wide="true"
            category="trafficdecision"
            view="list"
            linklabel="download"
          />

          <p v-if="locked && (values && values.Docs ? (values.Docs.TrafficDecision || []) : []).length === 0">
            Er is geen verkeersbesluit document beschikbaar
          </p>
        </div>
      </div>
      <div
        v-if="! reloading"
        class="DetailGrid__col2"
      >
        <div class="VKB_Instruction mt-3">
          <h4>
            Automatische datum koppeling
          </h4>
          <p>
            Bij het invoeren en wijzigen van de publicatie datum wordt de einddatum van de bezwaarperiode automatisch vastgesteld op 6 weken vanaf de publicatiedatum.
          </p>
          <p>
            Deze automatisch vastgestelde datum is altijd vrij aanpasbaar, maar wordt weer overschreven bij iedere wijziging van de publicatie datum.
          </p>
        </div>
      </div>

      <RealisationFooter
        :feedback="feedback"
        :feedback-message="feedbackMessage"
      >
        <b-button
          variant="outline-light"
          class="ml-3"
          size="sm"
          type="submit"
          :disabled="disabled"
          @click.prevent.stop="handlePrevious"
        >
          Vorige stap
        </b-button>

        <template v-if="! locked">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
          >
            Opslaan
          </b-button>
          <b-button
            v-if="step !== currentStep"
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleCancelChange"
          >
            Annuleren
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleSubmitAndNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else-if="mayEdit">
          <b-button
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleStartCorrection"
          >
            Corrigeren
          </b-button>
          <b-button
            v-if="openForChange"
            variant="outline-light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled"
            @click.prevent.stop="handleStartChange"
          >
            Wijzigen
          </b-button>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || disableNextBtn"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>

        <template v-else>
          <b-button
            variant="light"
            class="ml-3"
            size="sm"
            type="submit"
            :disabled="disabled || step <= currentStep"
            @click.prevent.stop="handleNext"
          >
            Volgende stap
          </b-button>
        </template>
      </RealisationFooter>
    </Form>
    <Comments :uuid="uuid" :version="version" @sync="handleSync" />
  </div>
</template>

<script>

import RealisationHeader from '@/components/realisation/RealisationHeader'
import RealisationFooter from '@/components/realisation/RealisationFooter'
import RealisationSidebar from '@/components/realisation/RealisationSidebar'

import Form from '@/components/form/Form'

import TrafficDecision from '@/components/definitions/TrafficDecision.vue'
// import FileUpload from '@/components/FileUpload'
import FilesManager from '@/components/files/FilesManager.vue'

import Comments from '@/components/Comments'

import BaseRealisationStep from '@/views/BaseRealisationStep'

import { mapGetters } from 'vuex'

export default {
  name: 'RealisationStep5',
  components: {
    RealisationSidebar, RealisationHeader, RealisationFooter,
    Form, Comments,
    TrafficDecision,
    // FileUpload,
    FilesManager
  },
  mixins: [BaseRealisationStep],
  data() {
    return {
      currentStep: '4',
    }
  },
  computed: {
    ...mapGetters('tenant', [
      'isCurrentTenant',
    ]),

    // Docs
    minTrafficDecisionDocsId() {
      try {
        return this.record.values.Docs.TrafficDecision.reduce((result, id) => Math.max(result, id), 0)
      } catch (e) {
        return 0
      }
    },
    isGORALTenant() {
      return this.isCurrentTenant({ tenant: 'go-ral' })
    },
  },
  created () {
    // Restore the previously saved data if current selection has not been saved
    // and if VLA, set the default on no VKB
    this.record.values.Location.TrafficDecision = this.values.raw.TrafficDecision
      ? JSON.parse(JSON.stringify(this.values.raw.TrafficDecision))
      : this.isCurrentTenant({ tenant: 'vlaanderen' }) && { TrafficDecisionNotApplicable: true }
  },
  methods: {
    prepData({ data }) {
      data.TrafficDecision.TrafficDecisionNotApplicable = !! data.TrafficDecision.TrafficDecisionNotApplicable

      // Falsy => null
      if (! data.TrafficDecision.PublicationDate) {
        data.TrafficDecision.PublicationDate = null
      }
      if (! data.TrafficDecision.DefinitiveDate) {
        data.TrafficDecision.DefinitiveDate = null
      }

      return data
    },

    /**
     * Typical 'v1.5' hack to update a value based on input from another field
     */
    handleDefinitiveDate({ trafficDecision }) {
      this.record.values.Location.TrafficDecision = trafficDecision
    },
  },
}
</script>

<style>
.VKB_Instruction {
  padding: 1rem;
  background: rgba(0, 0, 0, 0.05);
}
</style>
